$(document).ready(function () 
{
	var
		ua = navigator.userAgent.toLowerCase(),
		event = (ua.match(/Android/i) || ua.match(/iPad/i) || ua.match(/iPod/i) || ua.match(/iPhone/i)) ? "touchstart" : "click",
		isMobile = ua.match(/(iphone|ipod|ipad|android)/),
		window_w = $(window).width(),
		window_h = $(window).height(),
		is_home = $('body').hasClass('ishome');

	$('html').removeClass('no-js');

	if (("standalone" in window.navigator) && window.navigator.standalone) {
		$('html').addClass('ios-standalone');
	}

	if ($.browser.msie) {
		$('html').addClass('is-ie');
		$('html').addClass('ie-' + $.browser.versionNumber);
	}

	if ($.browser.msedge) {
		$('html').addClass('is-edge');
	}

	if ($.browser.iphone && $.browser.safari) {
		$('html').addClass('ios-safari');
	}

	if ($.browser.iphone && $.browser.chrome) {
		$('html').addClass('ios-chrome');
	}

	if ($.browser.android && $.browser.chrome) {
		$('html').addClass('android-chrome');
	}

	/**
	 * Embed responsive
	 */
	var iframe = $('.text iframe');
	if (iframe.length) {
		iframe.wrap("<div class='embed'></div>");
	}

	/**
	 * Trigger AOS
	 */
	setTimeout(function () {
		$('#loader').fadeOut(500, function () {
			$(this).remove();
		});
	}, 300);

	/**
	 * Fade loading images
	 */
	/* var load_images_bg = $("body").find(".gallery-grid .load-img:not(.loaded), .gallery-grid .load-img-uncover:not(.loaded)");
	if (load_images_bg.length) {
		load_images_bg.each(function (index, element) {
			var image = new Image(),
				$element = $(element),
				is_bg_or_img = typeof $element.data('src') !== 'undefined';

			image.onload = function () {
				if (is_bg_or_img) {
					$element.css("backgroundImage", "url('" + $element.attr("data-src") + "')").removeAttr('data-src');
				}
				setTimeout(function () {
					$element.parent().removeClass('loading');
					$element.addClass('loaded');
				}, 200);
			};
			image.src = is_bg_or_img ? $element.attr("data-src") : $element.find('img').attr('src');
		});
	} */

	/**
	 * Lazy load images
	 */
	var velcroLazy = {
        /**
         * init
		 * correr on load e sempre que for necessário, por exemplo, a seguir a uma call ajax
		 * elements: passar class dos ementos a fazer lazy load (ex: .lazy)
		 * ex: velcroLazy.init('.lazy');
         */
        init: (elements) => {
            let lazyImages = $(elements);

			if ("IntersectionObserver" in window) {
				var lazyImageObserver = new IntersectionObserver(function(entries, observer) {
					entries.forEach(function(entry) {
						if (entry.isIntersecting) {
							var lazyImage = $(entry.target),
								image = lazyImage.find('img')[0] || new Image(),
								is_bg_or_img = typeof lazyImage.data('src') !== 'undefined';

							image.onload = function () {
								if (is_bg_or_img) {//is bg
									lazyImage.css("backgroundImage", "url('" + lazyImage.data("src") + "')").removeAttr('data-src');
								}
								setTimeout(function () {
									lazyImage.addClass('loaded').removeClass("lazy").parent().removeClass('loading');
								}, 200);
							};

							image.src = is_bg_or_img ? lazyImage.data("src") : lazyImage.find('img').attr('data-src');
							lazyImageObserver.unobserve(entry.target);
						}
					});
				});

				lazyImages.each(function() {
					lazyImageObserver.observe(this);
				});
			} else {
				lazyImages.each(function() {
					var is_bg_or_img = typeof $(this).data('src') !== 'undefined';
					if (is_bg_or_img) {//is bg
						$(this).css("backgroundImage", "url('" + $(this).data("src") + "')").removeAttr('data-src');
					}else{//is img
						$(this).find('img').attr("src", $(this).find('img').data("src")).removeAttr('data-src');
					}
					$(this).addClass('loaded').removeClass("lazy").parent().removeClass('loading');
				});
			}
        }
	}

	velcroLazy.init('.lazy');

	var root = $('html,body');
	function smoothScrollingTo(target) {

		var target = $(target);
		if (target.length) {
			root.animate({
				scrollTop: target.offset().top - 100
			}, 400, "swing");
		}
	}

	$('a[href*=\\#]:not([href=\\#],[data-toggle],.open-popup)').on('click', function (event) {
		smoothScrollingTo(this.hash);
		if ($('.menu-mobile').hasClass('show')) {
			toogleMenu();
		}
	});

	smoothScrollingTo(location.hash);

	if (!Modernizr.objectfit) {
		$('body .objectfit').each(function () {
			var $container = $(this),
				imgUrl = $container.find('img').prop('src');
			if (imgUrl) {
				$container
					.css('backgroundImage', 'url(' + imgUrl + ')')
					.addClass('compat-object-fit');
			}
		});
	}

	$("a.nav-menu-open-icon").on( "click", function(e) {
		blockScroll(1);
	});

	$("a.nav-menu-close").on( "click", function(e) {
		blockScroll(0);
	});

	$('#load-more-brands').on('click', function() {
		$("#load_more").addClass('show');
		$('#load-more-brands').addClass('hide');
		var page = $(this).data('page');
		var search_query = $(this).data('search-query');
        var filter_id = $(this).data('filter-id');
        var data = {
            action: 'load_more_brands',
            page: page,
			search: search_query,
			filter: filter_id
        };
		$.post(main_script.ajaxurl, data, function(response) {
            // Append the new brands to the brand list
			$("#load_more").removeClass('show');
			if(response != "")
			{
				var json = JSON.parse(response);
				$('#brand-list').append(json.brands);
				$('#load-more-brands').data('page', page + 1);
				if(json.more)
					$('#load-more-brands').removeClass('hide');
				brandSliderStart();
			}
        });
    });

	var lazyNumbers = $('.numbers');
	if(lazyNumbers.length){
		var numbersObserver = new IntersectionObserver(function(entries, observer) {
			entries.forEach(function(entry) {
				if (entry.isIntersecting) {
					animateNumbers(entry.target, 0, $(entry.target).data('number'), $(entry.target).data('duration'));
					numbersObserver.unobserve(entry.target);
				}
			});
		});
	
		lazyNumbers.each(function() {
			numbersObserver.observe(this);
		});
	}

	if($('#fancy-datasheet').length){
		$('#datasheet_form').on( "submit", function(e) {
			e.preventDefault();

			$('.feedback').removeClass('ok error').text('');

			var form = $(e.target);
			var fields = form.serialize();

			form.find('input.btn-main').attr('disabled', 'disabled');

			$.ajax({
				url: main_script.ajaxurl,
				type: 'POST',
				data: fields,
				dataType: 'json',
				success: function (r) {
					if (r.success) {
						var link = document.createElement("a");
						link.setAttribute('download', r.data.basename);
						link.href = r.data.datasheet;
						document.body.appendChild(link);
						link.click();
						link.remove();
						form[0].reset();
						$('#pp').prop('checked', false).prev().removeClass('w--redirected-checked');
						$('.feedback').addClass('ok').text(r.data.message);
					} else {
						$('.feedback').addClass('error').text(r.data.message);
					}
					form.find('input.btn-main').removeAttr('disabled');
				},
				error: function (r) {
					$('.feedback').addClass('error').text(r.data.message);
					form.find('input.btn-main').removeAttr('disabled');
				}
			});
		});

		$('#pp').on( "change", function(e) {
			if($(this).is(':checked')){
				$(this).prev().addClass('w--redirected-checked');
			} else {
				$(this).prev().removeClass('w--redirected-checked');
			}
		});
	}
	if($("body.page-template-archive-brand").length > 0)
	{
		disableWebFlowAnimationsFromBrands();
	}
	brandSliderStart();	


	if($('.newsletter-form').length){
		$('#newsletter-form').on( "submit", function(e) {
			e.preventDefault();

			var form = $(e.target);
			var fields = form.serialize();

			form.find('.feedback').removeClass('ok error').text('');

			form.find('.inputs-container').addClass('disabled');

			$.ajax({
				url: main_script.ajaxurl,
				type: 'POST',
				data: fields,
				dataType: 'json',
				success: function (r) {
					if (r.success) {
						form[0].reset();
						form.find('#pp').prop('checked', false).prev().removeClass('w--redirected-checked');
						form.find('.feedback').addClass('ok').text(r.data.message);
					} else {
						form.find('.feedback').addClass('error').text(r.data.message);
					}
					form.find('.inputs-container').removeClass('disabled');
				},
				error: function (r) {
					form.find('.feedback').addClass('error').text(r.data.message);
					form.find('.inputs-container').removeClass('disabled');
				}
			});
		});
	}

	if($('.section-home-latest').length){
		var $el;
		var $a;
		var interval = setInterval(function() {
			$el = $("*[class^='elfsight-app']");
			$a = $el.find('a').last();
			if($a.length > 0){
				$a.remove();
				clearInterval(interval);
			}
		}, 1000);
	}

	// Range Slider
	if($('.swiper.is-range').length){
		const rangeSwiper = new Swiper(".swiper.is-range", {
			// Optional parameters
			//speed: sliderDuration,
			slidesPerView: 6,
			followFinger: true,
			keyboard: true,
			direction: "horizontal",
			slideToClickedSlide: false,
			//centeredSlides: true,
			centerInsufficientSlides: true,
			loop: false,
			speed: 800,
			spaceBetween: 16,
			mousewheel: {
			  forceToAxis: true
			},
			touchEventsTarget: "container",
			freeMode: true,
			breakpoints: {
				240: {
				  slidesPerView: 2
				  },
				478: {
				  slidesPerView: 4
				  },
				768: {
				  slidesPerView: 6
				  }
				},
		  });
	}
	
});


/**
 * Block scroll
 * @param block
 */
function blockScroll(block) {
	if (block == 1) {
		$('html').addClass('block-scroll');
	} else if (block == 0) {
		$('html').removeClass('block-scroll');
	}
}

function setCookie(name,value, days) {
	if (days) {
		var date = new Date();
		date.setTime(date.getTime()+(days*24*60*60*1000));
		var expires = "; expires="+date.toGMTString();
	}
	else var expires = "";
	document.cookie = name+"="+value+expires+"; path=/";
}

function brandSliderStart()
{
	$(".slider-main_component:not(.started)").each(function (index) 
	{
		let loopMode = false;
		$(this).addClass("started");
		if ($(this).attr("loop-mode") === "true") {
			loopMode = true;
		}
		let sliderDuration = 300;
		if ($(this).attr("slider-duration") !== undefined) {
			sliderDuration = +$(this).attr("slider-duration");
		}
		const swiper = new Swiper($(this).find(".swiper")[0], 
		{
			speed: sliderDuration,
			autoHeight: false,
			followFinger: true,
			freeMode: true,
			slideToClickedSlide: false,
			slidesPerView: "auto",
			spaceBetween: 16,
			rewind: false,
			mousewheel: {
				forceToAxis: true
			},
			breakpoints: {
				320: {
				spaceBetween: 16
				},
				480: {
				spaceBetween: 16
				}
				},
			keyboard: {
				enabled: true,
				onlyInViewport: true
			},
			pagination: {
				el: $(this).find(".swiper-bullet-wrapper")[0],
				bulletActiveClass: "is-active",
				bulletClass: "swiper-bullet",
				bulletElement: "button",
				clickable: true
			},
			navigation: {
				nextEl: $(this).find(".swiper-next")[0],
				prevEl: $(this).find(".swiper-prev")[0],
				disabledClass: "is-disabled"
			},
			slideActiveClass: "is-active",
			slideDuplicateActiveClass: "is-active"
		});
	});
}


  function animateNumbers(element, start, end, duration) {
	let obj = $(element).find('span'),
	 current = start,
	 range = end - start,
	 increment = end > start ? 1 : -1,
	 step = Math.abs(Math.floor(duration / range)),
	 timer = setInterval(() => {
	  current += increment;
	  obj.text(current);
	  if (current == end) {
	   clearInterval(timer);
	  }
	 }, step);
   }

   function disableWebFlowAnimationsFromBrands(){
		const cancelAnimationsInterval = setInterval(function () 
		{
			if (typeof Webflow == "undefined" || typeof Webflow.require == "undefined") {
				return;
			}

			clearInterval(cancelAnimationsInterval);

			// Get the interactions data from Webflow's state
			const interactionsData = Webflow.require('ix2').store.getState().ixData;
			// Filter out all non-click events from the interactions
			interactionsData.events = Object.fromEntries(
				Object.entries(interactionsData.events).filter(eventEntry => 
				{
					if(eventEntry[1].eventTypeId != "MOUSE_OVER" && eventEntry[1].eventTypeId != "MOUSE_OUT")
						return true;
					if(eventEntry[1].target.id != "58a38489-b9a1-3ff4-3025-e86fede67051" && eventEntry[1].target.id != "58a38489-b9a1-3ff4-3025-e86fede67052")
						return true;
					return false;
				})
			);
			// Put the data in the format that Webflow expects it
			interactionsData.site = { mediaQueries: interactionsData.mediaQueries };

			// Stop Webflow's handling of animations
			Webflow.require("ix2").destroy();

			// Re-initialize Webflow interactions for click-related events only
			Webflow.require('ix2').init(interactionsData);
			document.dispatchEvent(new Event('readystatechange'));
		}, 10);
	}
   
	function addEvent(event, selector, callback, context) {
		document.addEventListener(event, e => {
			if ( e.target.closest(selector) ) {
				callback(e);
			}
		});
	}
	addEvent('click', '.cmplz-show-banner', function(){
		document.querySelectorAll('.cmplz-manage-consent').forEach(obj => {
			obj.click();
		});
	});